import moment from 'moment';

import { getFields } from '../../../utils';

const startDate = moment().subtract(90, 'days');
const currentDate = moment();

const fields = ['contract'];

const schema = getFields(fields);

schema.contract = { ...schema.contract, id: 'contract', label: 'Contrato', required: false };

const newSchema = {
    type: {
        id: 'type',
        label: '',
        value: 'perBeneficiary',
        required: true,
        type: 'radio',
        options: [
            { codigo: 'perBeneficiary', nome: 'Por beneficiário' },
            { codigo: 'perOperation', nome: 'Por operação' },
            { codigo: 'perProtocol', nome: 'Por protocolo' },
        ],
    },
    identity: {
        id: 'identity',
        label: 'N° da carteirinha, nome ou CPF',
        required: false,
        type: 'text',
    },
    period: {
        id: 'period',
        label: 'Período',
        required: true,
        type: 'daterange',
        value: [startDate, currentDate],
    },
    operationType: {
        id: 'operationType',
        label: 'Tipo de operacação',
        required: false,
        type: 'select',
        placeholder: 'Todos',
        options: [
            {
                codigo: 'InclusaoTitular',
                nome: 'Inclusão do titular',
            },
            {
                codigo: 'InclusaoDependente',
                nome: 'Inclusão do dependente',
            },
            {
                codigo: 'AlteracaoCadastral',
                nome: 'Alteração cadastral',
            },
            {
                codigo: 'TransferenciaDeContrato',
                nome: 'Transferência de contrato',
            },
            {
                codigo: 'TrocaDePlano',
                nome: 'Troca de plano',
            },
            {
                codigo: 'Reativacao',
                nome: 'Reativação',
            },
            {
                codigo: 'Exclusao',
                nome: 'Exclusão',
            },
            {
                codigo: 'AposentadosDemitidos',
                nome: 'Aposentados e demitidos',
            },
        ],
    },
    status: {
        id: 'status',
        label: 'Status',
        required: false,
        type: 'select',
        placeholder: 'Todos',
        options: [
            {
                codigo: 1,
                nome: 'Processado',
            },
            {
                codigo: 2,
                nome: 'Recusado',
            },
            {
                codigo: 3,
                nome: 'Reenviar',
            },
        ],
    },
    protocol: {
        id: 'protocol',
        label: 'Protocolo',
        required: false,
        type: 'text',
    },
};

export default { ...schema, ...newSchema };
